import { render, staticRenderFns } from "./loader.vue?vue&type=template&id=e4b3c4ce&scoped=true&"
import script from "./loader.vue?vue&type=script&lang=js&"
export * from "./loader.vue?vue&type=script&lang=js&"
import style0 from "./loader.vue?vue&type=style&index=0&id=e4b3c4ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4b3c4ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/django/skokka/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e4b3c4ce')) {
      api.createRecord('e4b3c4ce', component.options)
    } else {
      api.reload('e4b3c4ce', component.options)
    }
    module.hot.accept("./loader.vue?vue&type=template&id=e4b3c4ce&scoped=true&", function () {
      api.rerender('e4b3c4ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/static/js/components/ui/loader.vue"
export default component.exports